import "../css/tsuru.css";
/* DEFAULT.HBS */
const bodyClassList = document.getElementById("body").classList;
const template = bodyTemplate();
const metaTemplate = bodyMetaTemplate();
const autoIndent = bodyClassList.contains("auto-indent");
const navigation = bodyClassList.contains("navigation");
const secondaryNavigation = bodyClassList.contains("secondary-navigation");
const showTags = bodyClassList.contains("show-tags");
const dateFormat = bodyDateFormat();
/* Variables for Post.js */
let pixelsByRem;
		    let contentBodyElem;
			let contentBodyPElemsNb;
var firstClick = true; // To skip the 1st click which occurs as soon as the event listener has been added.

function bodyDateFormat() {
  if (bodyClassList.contains("date-format-western")) {return "date-format-western";}
  else if (bodyClassList.contains("date-format-japanese")) {return "date-format-japanese";}
  else if (bodyClassList.contains("date-format-kanji")) {return "date-format-kanji";}
  else if (bodyClassList.contains("date-format-era-japanese")) {return "date-format-era-japanese";}
  else if (bodyClassList.contains("date-format-era-kanji")) {return "date-format-era-kanji";}
  return("unknown");
}
function bodyTemplate() {
  if (bodyClassList.contains("post-template")) {return "post-template";}
  else if (bodyClassList.contains("home-template")) {return "home-template";}
  else if (bodyClassList.contains("page-template")) {return "page-template";}
  else if (bodyClassList.contains("tag-template")) {return "tag-template";}
  else if (bodyClassList.contains("author-template")) {return "author-template";}
  else if (bodyClassList.contains("private-template")) {return "privace-template";}
  return("unknown");
}
function bodyMetaTemplate() {
  switch(template) {
	case "home-template":
    case "tag-template":
      return "list";
    case "page-template":
    case "post-template":
    case "author-template":
    case "private-template":
      return "content";
    default:
      return "unknown";
  }
}
function adjustResponsiveElements() {
  if (metaTemplate == "list") {
	responsiveSocialMedia();
    responsivePrimaryNavigationMenu();
    if (document.getElementById("page-head-title")) {
      responsiveSiteDescription();
    }
    responsivePostcardExcerpts();
  }
  if (metaTemplate == "content") {
    document.getElementById("post-content-title").style.fontSize = "48px";
    responsiveTitle();
    responsiveImages();
    if (contentBodyPElemsNb > 0) {
	  responsiveBodyContainer();
    }
    responsivePrimaryNavigationMenu();
    responsiveHamburger();
  }
}
window.onresize = adjustResponsiveElements;
document.onreadystatechange = function() {   if (document.readyState === "complete") { 
 let bodyStyle = getComputedStyle(document.getElementsByTagName("body")[0]);
	    let pixelsByRem = parseInt(bodyStyle.fontSize);
		setDarkAccentColor();
		$("time").each(function (i, date) {
            var $date = $(date);
            $date.html(formatDate(new Date($date.attr('datetime'))))
		});
		if (metaTemplate == "content") {
			// segmentPostContentTitle();
	        // 1. Auto-indent the first paragraph rows, depending on the custom option. 2. Append the tag list at the very end of the post content body. 3. Insert the author link(s) at the end of the last content body paragraph 4. Interrupt the multi-column layout for wide and full-width cards.
	        var viewportHeight = window.innerHeight;
		    var contentBodyElem = document.getElementsByClassName("post-content-body").item(0); // The HTML file contains only one post-content-body.
			var contentBodyPElems = contentBodyElem.getElementsByTagName('p');
			if (autoIndent) {
				// Add the "not-a-quote" class to the paragraphs that don't start with a quotation/parenthesis mark
				for(var i=0, contentBodyPElems; contentBodyPElems[i]; i++) {
                    let pElem = contentBodyPElems[i];
					let firstChar=pElem.innerText.charAt(0);
					if ( (firstChar === "") | (firstChar === "「") | (firstChar === "『") | (firstChar === "＜") | (firstChar === "《") | (firstChar === "（") | (firstChar === "【") ) {continue;}
					pElem.classList.add("not-a-quote");
				}
			}
			contentBodyPElemsNb = contentBodyPElems.length;
			let tagListElem = document.getElementById("tag-list");
			if (tagListElem !== null) {
					contentBodyElem.appendChild(tagListElem);
			}
			if (contentBodyPElemsNb > 0) {
				let contentBodyLastPElem = contentBodyPElems.item(contentBodyPElemsNb - 1);
				contentBodyLastPElem.style.widows = 3;
				// Move the author signature to the end of the last paragraph
				contentBodyLastPElem.appendChild(document.getElementById("author-signature"));
			} //else there is no text in the last part of the body...
			const wideCards = document.querySelectorAll('.kg-width-wide, .kg-width-full');

			wideCards.forEach(wideCard => {
				if (!wideCard.previousElementSibling) {
					// If the wide card is at the top of the body, bring it just before it.
					wideCard.parentNode.insertAdjacentElement("beforebegin",wideCard);
				}
				else {
					if (wideCard.nextElementSibling) {
						// If there are some elements after the wide card, create a new content-body (along with its spacer), and put the next siblings there.
						var newContentBody = wideCard.parentNode.cloneNode(false);
						var newContentBodySpacer = wideCard.parentNode.nextElementSibling.cloneNode(false);
						while (wideCard.nextElementSibling) {
							newContentBody.appendChild(wideCard.nextElementSibling);
						}
						wideCard.parentNode.nextElementSibling.insertAdjacentElement("afterend",newContentBody);
						wideCard.parentNode.nextElementSibling.nextElementSibling.insertAdjacentElement("afterend",newContentBodySpacer);
					}
				// The wide card is now the last element of the body
				wideCard.parentNode.nextElementSibling.insertAdjacentElement("afterend",wideCard);
				}

			});

		}
        adjustResponsiveElements();
		document.getElementById("site-head-container").style.opacity = 1;
	   if (metaTemplate == "list") {
		    if (document.getElementById("page-head-title")) {
                document.getElementById("page-head-title").style.opacity = 1;
			}
		}
		if (showTags && template=="home-template") {
		    improveTagContrast();
		}
		if (template=="tag-template" || template=="post-template") {
		    improveTagContrast();
		}
		if (metaTemplate == "content") {
		    alphanumericalUpright();
			$("h1,h2,h3,h4,h5,h6").css({opacity: '1'});
			$("#post-content-body-container").css({opacity: '1'});
			responsiveImages(); // this second call is necessary for positioning the overlaid caption
			responsiveHamburger();
		}
}
}
/* END DEFAULT.HBS */
/*function segmentPostCardTitle() {
	var postCardTitleElems = document.getElementsByClassName("post-card-title");
	for (i = 0; i < postCardTitleElems.length; i++) {
		postCardTitleElems[i].innerHTML = postCardTitleElems[i].textContent;
	}
}*/
/* COMMON.JS */

const kanjiDigits = ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
function toKanji(num) {
  return num.toString().split('').map(digit => kanjiDigits[parseInt(digit)]).join('');
}

function formatDate(dateObject) {
	switch(dateFormat) {
        case "date-format-western": return `${dateObject.getFullYear()}/${dateObject.getMonth()+1}/${dateObject.getDate()}`;
        case "date-format-kanji": return `${toKanji(dateObject.getFullYear())}年\u200b${toKanji(dateObject.getMonth()+1)}月${toKanji(dateObject.getDate())}日`;
        case "date-format-era-japanese": return `令和${dateObject.getFullYear()-2018}年${dateObject.getMonth()+1}月${dateObject.getDate()}日`;
        case "date-format-era-kanji": return `令和${toKanji(dateObject.getFullYear()-2018)}年\u200b${toKanji(dateObject.getMonth()+1)}月${toKanji(dateObject.getDate())}日`;
        default: return `${dateObject.getFullYear()}年${dateObject.getMonth()+1}月${dateObject.getDate()}日`;
    }
}
// Color functions
// color format is either #123456 or rgb(128, 0, 255)
// Internal color format (named rgb): red, blue and green between O and 255
function hexTorgb(h) {
  let r = 0, g = 0, b = 0;
  if (h.length == 7) {
    r = parseInt(h.substring(1, 3), 16);
    g = parseInt(h.substring(3, 5), 16);
    b = parseInt(h.substring(5), 16);
  }
  return {r:r, g:g, b:b};
}
function rgbToRGB(r, g, b) {
	return "rgb("+ r + "," + g + "," + b + ")";
}
function RGBTorgb(color) {
	// Format is rgb(128, 0, 255)
	color = color.substring(4, color.length -1);
	const myArray = color.split(",");
	r = parseInt(myArray[0].trim());
	g = parseInt(myArray[1].trim());
	b = parseInt(myArray[2].trim());
	return {r:r, g:g, b:b};
}
function toHex(n) {
  n = Math.round(n);
  var hex = n.toString(16);
  while (hex.length < 2) {hex = "0" + hex; }
  return hex;
}
function rgbToHex(red, green, blue) {
    var r = toHex(red);
    var g = toHex(green);
    var b = toHex(blue);
    return "#" +  r + g + b;
  }
function rgbTohsl(r, g, b) { // From https://www.w3schools.com/lib/w3color.js
  var min, max, i, l, s, maxcolor, h, rgb = [];
  rgb[0] = r / 255;
  rgb[1] = g / 255;
  rgb[2] = b / 255;
  min = rgb[0];
  max = rgb[0];
  maxcolor = 0;
  for (i = 0; i < rgb.length - 1; i++) {
    if (rgb[i + 1] <= min) {min = rgb[i + 1];}
    if (rgb[i + 1] >= max) {max = rgb[i + 1];maxcolor = i + 1;}
  }
  if (maxcolor == 0) {
    h = (rgb[1] - rgb[2]) / (max - min);
  }
  if (maxcolor == 1) {
    h = 2 + (rgb[2] - rgb[0]) / (max - min);
  }
  if (maxcolor == 2) {
    h = 4 + (rgb[0] - rgb[1]) / (max - min);
  }
  if (isNaN(h)) {h = 0;}
  h = h * 60;
  if (h < 0) {h = h + 360; }
  l = (min + max) / 2;
  if (min == max) {
    s = 0;
  } else {
    if (l < 0.5) {
      s = (max - min) / (max + min);
    } else {
      s = (max - min) / (2 - max - min);
    }
  }
  s = s;
  return {h : h, s : s, l : l}; // saturation and lighness are between 0 and 1;
}
function hueTorgb(t1, t2, hue) {
  if (hue < 0) hue += 6;
  if (hue >= 6) hue -= 6;
  if (hue < 1) return (t2 - t1) * hue + t1;
  else if(hue < 3) return t2;
  else if(hue < 4) return (t2 - t1) * (4 - hue) + t1;
  else return t1;
}
function hslTorgb(hue, sat, light) {
  var t1, t2, r, g, b;
  hue = hue / 60;
  if ( light <= 0.5 ) {
    t2 = light * (sat + 1);
  } else {
    t2 = light + sat - (light * sat);
  }
  t1 = light * 2 - t2;
  r = hueTorgb(t1, t2, hue + 2) * 255;
  g = hueTorgb(t1, t2, hue) * 255;
  b = hueTorgb(t1, t2, hue - 2) * 255;
  return {r : r, g : g, b : b};
}
// Determine if a color is light or not
// Use Red Green Blue values from 0 to 255 as parameters
function brightness(color) { // returns 0 for black and 255 for white
    // Supported formats: #aabbcc or rgb(123, 12, 212)
    // See https://www.nbdtech.com/Blog/archive/2008/04/27/calculating-the-perceived-brightness-of-a-color.aspx
	//let c = new Object();
    if (color[0] == '#') 
	  { var c = hexTorgb(color);}
    else 
	  {	var c = RGBTorgb(color);}
	return (Math.sqrt((0.241*c.r*c.r) + (0.691*c.g*c.g) + (0.068*c.b*c.b)));
}
function inverseLightness(color) {// Supported formats: #aabbcc or rgb(123, 12, 212)
    if (color[0] == '#') 
	  { var c = hexTorgb(color);}
    else 
	  {	var c = RGBTorgb(color);}
	let chsl = rgbTohsl(c.r, c.g, c.b);
	chsl.l = 1 - chsl.l; // Invert the lightness
	let darkc = hslTorgb(chsl.h, chsl.s, chsl.l);	
	return (rgbToHex(darkc.r, darkc.g, darkc.b));
}
function isLight(color) {
	return (brightness(color) >= 130);
}
function isDark(color) {
return (brightness(color) < 130);
}
function isVeryDark(color) {
	return (brightness(color) < 60);
}
function setDarkAccentColor() { // We suppose that the accent color has been set for the light mode
	// If it is very dark (in the light mode), we turn it into very light for the dark mode
	let matched = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const accentColor = getComputedStyle(document.documentElement).getPropertyValue('--ghost-accent-color');
    if ((matched) && (isVeryDark(accentColor))) {
		let darkModeAccentColor=inverseLightness(accentColor);
		document.documentElement.style.setProperty('--ghost-accent-color', darkModeAccentColor);
	}
}
function improveTagContrast() { 
    // 1. Lighten the tag background color if it is very dark (dark mode only)
	// 2. Change the color of the tag text depending on the tag color
	let matched = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const accentColor = getComputedStyle(document.documentElement).getPropertyValue('--ghost-accent-color');
    let tagElems = document.getElementsByClassName("tag");
    for (let i = 0; i < tagElems.length; i++) {
	    let tagElem = tagElems.item(i);
		let tagStyle = tagElem.style;
	    let tagBackgroundColor = accentColor;
	    if (tagStyle.backgroundColor) {
			tagBackgroundColor = tagStyle.backgroundColor;
			if ((matched) && (isVeryDark(tagBackgroundColor))) {
			    tagBackgroundColor=inverseLightness(tagBackgroundColor);
				tagElem.style.backgroundColor = tagBackgroundColor;
			}
	    }
		if (isLight(tagBackgroundColor)) {
			tagElem.classList.add("dark-text");
		}
    }
}
/* END COMMON.JS */
function headHasEnoughSpace() {
	// Is there enough space in the head container to layout properly all its content.
	var emInPx = parseInt(window.getComputedStyle(document.getElementById("site-head-container")).getPropertyValue('font-size'));
    var $siteHeadElems = $('#site-head-container').children().filter(function() {
        return $(this).css('display') != 'none';
    });
	if ($siteHeadElems.length == 2) {
		var gutter = $siteHeadElems[1].firstElementChild.firstElementChild.getBoundingClientRect().left - $siteHeadElems[0].lastElementChild.lastElementChild.getBoundingClientRect().right;
		if (gutter < (4 * emInPx)) {return false;}
	}
	if ($siteHeadElems.length == 3) {
		var leftGutter = $siteHeadElems[1].firstElementChild.firstElementChild.getBoundingClientRect().left - $siteHeadElems[0].lastElementChild.lastElementChild.getBoundingClientRect().right;
	    var rightGutter = $siteHeadElems[2].firstElementChild.firstElementChild.getBoundingClientRect().left - $siteHeadElems[1].lastElementChild.lastElementChild.getBoundingClientRect().right;
		if ((leftGutter+rightGutter) < (8 * emInPx)) {return false;}
	}
	return true;
}
function responsiveSocialMedia() {
	//If the social links eat too much space in the site head, or if there is no menu to display on the left-hand side, remove the words Facebook, Twitter, RSS
	if ($(".gh-social-name").length !== 0){
		if ((document.getElementById("site-head-left")) && headHasEnoughSpace()) {
			$(".gh-social-name").css("display", "inline");
			document.getElementById("site-head-right").style.flexGrow = 1;
		}
	    else {
       	    $(".gh-social-name").css("display", "none");
			document.getElementById("site-head-right").style.flexGrow = 0;
	    }
	}
}

function responsivePrimaryNavigationMenu() {
	// if ($("#site-head-title").is(":first-child")) {return;} // There is no primary navigation menu
	if (navigation) {
	// If the primary menu (displayed horizontally) eats too much space, hide it (along with the social media icons) and display instead a vertical menu actionnable via a Hamburger Button
	// First, restore the DOM before calling headHasEnoughSpace()
	if (document.getElementById("site-head-left")) {
		document.getElementById("site-head-container").insertBefore(document.getElementById("site-head-left"), document.getElementById("site-head-title"));
	}
	if (document.getElementById("site-head-right")) {
		document.getElementById("site-head-container").appendChild(document.getElementById("site-head-right"));
	}
	if (document.getElementById("mobile-menu-container")) {
		document.getElementById("mobile-menu-container").remove();
	}

	if (headHasEnoughSpace()) {
		document.getElementById("site-head-container").style.gap = "3em";
		if (document.getElementById("hamburger-btn")) {
		    document.getElementById("hamburger-btn").style.display = "none";
		}
		if (document.getElementById("site-head-left")) {
		    document.getElementById("site-head-left").style.display = "flex";
			// If there is no social media, split the navigation menu in 2 parts around the site title
			if ( (!document.getElementById("site-head-right")) && (document.getElementById("site-head-left").childElementCount > 1) ) {
				var rightNavMenuElem = document.createElement("ul");
				rightNavMenuElem.setAttribute("id", "site-head-right");
				while ( rightNavMenuElem.childElementCount < (document.getElementById("site-head-left").childElementCount - 1) ){
					rightNavMenuElem.appendChild(document.getElementById("site-head-left").lastElementChild);
				}
				document.getElementById("site-head-container").appendChild(rightNavMenuElem);
			}
		}
		if (document.getElementById("site-head-right")) {
            document.getElementById("site-head-right").style.display = "flex";
		}
	}
	else {
		document.getElementById("site-head-container").style.gap = "0em";
		if (document.getElementById("hamburger-btn")) {
	        document.getElementById("hamburger-btn").style.display = "inline-block";
		}
		var mobileMenuContainerElem = document.createElement("div");
		mobileMenuContainerElem.setAttribute("id", "mobile-menu-container");
		var mobileMenuElem = document.createElement("div");
		mobileMenuElem.setAttribute("id", "mobile-menu");
		mobileMenuContainerElem.appendChild(mobileMenuElem);
		if (document.getElementById("site-head-left")) {
            document.getElementById("site-head-left").style.display = "block";
			mobileMenuElem.appendChild(document.getElementById("site-head-left"));
		}
		if (document.getElementById("site-head-right")) {
            document.getElementById("site-head-right").style.display = "block";
			mobileMenuElem.appendChild(document.getElementById("site-head-right"));
		}
		document.getElementById("site-head-container").appendChild(mobileMenuContainerElem);
    }
	}
}
function responsiveSiteDescription() {
	document.getElementById("page-head-title").style.paddingLeft = 0;
	document.getElementById("page-head-title").style.paddingRight = 0;
	// If the site description is brief, center it just below the site title
    // Width of the site description
	var pageHeadTitleRect = document.getElementById("page-head-title").getBoundingClientRect();
	var pageHeadTitleCenterXPos = (pageHeadTitleRect.right + pageHeadTitleRect.left) / 2;
	var pageHeadTitleWidth = pageHeadTitleRect.right - pageHeadTitleRect.left;
	// Horizontal position of the center of the site title
	var siteHeadLogoRect = document.getElementById("site-head-logo").getBoundingClientRect();
	var siteHeadLogoCenterXPos = (siteHeadLogoRect.right + siteHeadLogoRect.left) / 2;
	if (siteHeadLogoCenterXPos > pageHeadTitleCenterXPos) {
	    // Try to move the site description to the right
	    var parentRight =  document.getElementById("page-head").getBoundingClientRect().right;
	    if ((siteHeadLogoCenterXPos + (pageHeadTitleWidth / 2)) < parentRight) {
		    // As the block is centered automatically from flex, the left padding is doubled.
            document.getElementById("page-head-title").style.paddingLeft = 2 *	(siteHeadLogoCenterXPos - pageHeadTitleCenterXPos)+"px";
		}
	} else {
	    // Try to move the site description to the left
	    var parentLeft =  document.getElementById("page-head").getBoundingClientRect().left;
		if ((siteHeadLogoCenterXPos - (pageHeadTitleWidth / 2)) > parentLeft) {
		    // As the block is centered automatically by the parent flex, the right padding is doubled.
                document.getElementById("page-head-title").style.paddingRight = 2 *	(pageHeadTitleCenterXPos - siteHeadLogoCenterXPos)+"px";
		}
	}
}
var firstClick = true; // To skip the 1st click which occurs as soon as the event listener has been added.
function handleClick(event) {
	if (!firstClick) {
	 if (!document.getElementById('mobile-menu-container').contains(event.target)){
          closeMobileMenu();
      }
	} else {
		firstClick = false;
	}
}
function closeMobileMenu() {
	document.getElementById("mobile-menu-container").style.left = "-90%";
    document.documentElement.style.setProperty("--color-triangle", "transparent");
	window.removeEventListener("click", handleClick);
	firstClick = true;
}
function openMobileMenu() {
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
  var offset = 9 + document.getElementById("hamburger-btn").getBoundingClientRect().bottom;
  document.documentElement.style.setProperty("--offset-mobile-menu", offset+"px");
  document.getElementById("mobile-menu-container").style.left = 0;
  if (prefersDarkScheme.matches) {
	document.documentElement.style.setProperty("--color-triangle", "rgb(66, 66, 66)");
  } else {
    document.documentElement.style.setProperty("--color-triangle", "white");
  }
  window.addEventListener("click", handleClick);
}
function responsivePostcardExcerpt(postcardElem) {
	// Adjust the number of rows that the excerpts can display.
	const emInPx = parseInt(window.getComputedStyle(postcardElem).getPropertyValue('font-size'));
	const lineHeight = emInPx * 1.2;
	// Date + top padding takes 3x12 = 36 px.
	// Bottom padding takes 1 line.
	var postcardHeightInPx = postcardElem.clientHeight;
	var postcardTitleHeightInPx = 0;
	var postcardTitleElems = postcardElem.getElementsByTagName("h2");
	if (postcardTitleElems.length == 1) {
		postcardTitleHeightInPx = postcardTitleElems.item(0).clientHeight;
	}
	var postcardExcerptElems = postcardElem.getElementsByTagName("p");
	if (postcardExcerptElems.length == 1) {
		let lineClamp = Math.floor(((postcardHeightInPx - postcardTitleHeightInPx - 12)/lineHeight)) - 2;
		if (lineClamp > 0) {
		    postcardExcerptElems.item(0).style.webkitLineClamp = lineClamp;
		}
	}
}
function responsivePostcardExcerpts() {
	var $postcardElems = $('.post-card').filter(function() {
        return $(this).has('p').length > 0;
    });
    $postcardElems.each(function() {
		responsivePostcardExcerpt($(this)[0]);
	});
}
/* POST.JS */
/*function segmentPostContentTitle(){
	document.getElementById("post-content-title").innerHTML = document.getElementById("post-content-title").textContent;
}*/
function headHasEnoughSpace2() {
	// Is there enough space in the head container to layout properly all its content.
	var emInPx = parseInt(window.getComputedStyle(document.getElementById("site-head-container")).getPropertyValue('font-size'));
    var $siteHeadElems = $('#site-head-container').children().filter(function() {
        return $(this).css('display') != 'none';
    });
	if ($siteHeadElems.length == 2) { // Computer layout
		var gutter = $siteHeadElems[1].firstElementChild.firstElementChild.getBoundingClientRect().left - $siteHeadElems[0].lastElementChild.getBoundingClientRect().right;
		if (gutter < (3.5 * emInPx)) {return false;}
	}
	if ($siteHeadElems.length == 1) { // Mobile layout
		if ($siteHeadElems[0].childElementCount > 1) {
			var gutter = $siteHeadElems[0].children[1].firstElementChild.getBoundingClientRect().left - $siteHeadElems[0].children[0].firstElementChild.getBoundingClientRect().right;
			if (gutter < emInPx) {return false;}
		}
	}
	return true;
}

function alphanumericalUpright() {
    //Display 1 or 2 alphanumerical characters upright. Workaround to be replaced by "text-combine-upright: digits 2" when supported by major browsers.
	$("p,h1,h2,h3,h4,h5,h6").each(function(){
	    $(this).html($(this).html().replace(/(^|[^a-zA-Z])([a-zA-Z]{1,2})(?![a-zA-Z])(?=[^>]*(<|$))/g, '$1<span class="up">$2</span>'));
        $(this).html($(this).html().replace(/(^|[^0-9\.])([0-9]{1,2})(?![0-9\.])(?=[^>]*(<|$))/g, '$1<span class="up">$2</span>'));
	    $(this).html($(this).html().replace(/([!\?]{1,2})/g, '<span class="up">$1</span>'));
    });
}

function responsiveBodyContainer() {
	// 1. Center vertically the post/page content body if it is short, i.e. if the viewport can display more rows than what is actually needed. 2. Set the height of the empty post-content-body-spacer divs to make the multi-row layout workable.
	// Reset the layout
	const contentBodySpacerElems = document.getElementsByClassName("post-content-body-spacer");
	for (let i = 0; i < contentBodySpacerElems.length; i++) {
		contentBodySpacerElems.item(i).style.height = '0px';
	}
	document.getElementById("post-content-body-container").style.alignContent = 'flex-start';
	var contentBodyElems = document.getElementsByClassName("post-content-body");
	for (let j = 0; j < contentBodyElems.length; j++) {
		var contentBodyElem = contentBodyElems.item(j);
		var contentBodyTopYPos = contentBodyElem.getBoundingClientRect().top + window.scrollY;
		// Get the Y-coordinate of the end of the body
		var lastRowBottomYPos = contentBodyElem.lastElementChild.getBoundingClientRect().bottom + window.scrollY;
		// The body (height) covers the 1st row block
		var contentBodyHeight = parseInt(getComputedStyle(contentBodyElem).height);
		// The spacer (height) covers the 2..n row blocks
		var bodySpacerHeight = lastRowBottomYPos - contentBodyHeight - contentBodyTopYPos;
		if ( (bodySpacerHeight < 2) && (contentBodyElem.parentNode.childElementCount < 3) ) { // There is only 1 row block.
		//	Add nevertheless a small spacer to push the text up a bit.
			var contentBodyContainerStyle = getComputedStyle(document.getElementById("post-content-body-container"));
			bodySpacerHeight = 0.3 * (parseInt(contentBodyContainerStyle.height) - contentBodyHeight) ;
		}
		contentBodyElem.nextElementSibling.style.height = bodySpacerHeight+'px';
	}
	document.documentElement.style.setProperty("--column-width", contentBodyHeight+'px');
	document.documentElement.style.setProperty("--column-gap", getComputedStyle(contentBodyElem).columnGap);
	// Restore the layout
    document.getElementById("post-content-body-container").style.alignContent = 'center';
};
function responsiveNavigationMenu() {
	// If the primary (displayed horizontally) eats too much space, hide it and display instead a vertical menu actionnable via a Hamburger Button
	// First, restore the DOM before calling headHasEnoughSpace2()
	if (document.getElementById("site-head-left")) {
		document.getElementById("site-head-container").appendChild(document.getElementById("site-head-left"));
	}
	if (document.getElementById("site-head-right")) {
		document.getElementById("site-head-container").appendChild(document.getElementById("site-head-right"));
	}
	if (document.getElementById("mobile-menu-container")) {
		document.getElementById("mobile-menu-container").remove();
	}
	if (headHasEnoughSpace2()) {
		if (document.getElementById("home-btn")) {
		    document.getElementById("home-btn").style.display = "inline-block";
			document.getElementById("home-btn").classList.add("show");
		}
		if (document.getElementById("hamburger-btn")) {
		    document.getElementById("hamburger-btn").style.display = "none";
			document.getElementById("hamburger-btn").classList.remove("show");
		}
		if (document.getElementById("site-head-left")) {
			document.getElementById("site-head-left").style.display = "flex";
		}
	}
	else {
		if (document.getElementById("home-btn")) {
		    document.getElementById("home-btn").style.display = "none";
			document.getElementById("home-btn").classList.remove("show");
		}
		if (document.getElementById("hamburger-btn")) {
		    document.getElementById("hamburger-btn").style.display = "inline-block";
			document.getElementById("hamburger-btn").classList.add("show");
		}
		var mobileMenuContainerElem = document.createElement("div");
		mobileMenuContainerElem.setAttribute("id", "mobile-menu-container");
		var mobileMenuElem = document.createElement("div");
		mobileMenuElem.setAttribute("id", "mobile-menu");
		mobileMenuContainerElem.appendChild(mobileMenuElem);
		if (document.getElementById("site-head-left")) {
            document.getElementById("site-head-left").style.display = "block";
			mobileMenuElem.appendChild(document.getElementById("site-head-left"));
		}
		if (document.getElementById("site-head-right")) {
            document.getElementById("site-head-right").style.display = "block";
			mobileMenuElem.appendChild(document.getElementById("site-head-right"));
		}
		document.getElementById("site-head-container").appendChild(mobileMenuContainerElem);
    }
}
function responsiveHamburger(){
	// On mobile phones, do not show the navigation button over the header picture

	if ( (window.innerWidth < 501) && "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype ) {
        let observer = new IntersectionObserver(entries => {
            if (entries[0].boundingClientRect.bottom < 0) {
				document.getElementsByClassName("show").item(0).style.display = "inline-block";
            }
            else {
                document.getElementsByClassName("show").item(0).style.display = "none";
            }
        });
        observer.observe(document.querySelector("#site-head-container"));
    }
	else {
		document.getElementsByClassName("show").item(0).style.display = "inline-block";
	}

}
if (navigation) {
  document.getElementById("hamburger-btn").addEventListener("click", openMenu);
}
function openMenu() {
	if (metaTemplate == "list") {openMobileMenu();}
	else if (metaTemplate == "content") {openMobileMenu2();}
}

function handleClick2(event) {
	if (!firstClick) {
	 if (!document.getElementById('mobile-menu-container').contains(event.target)){
          closeMobileMenu2();
      }
	} else {
		firstClick = false;
	}
}
function closeMobileMenu2() {
	document.getElementById("mobile-menu-container").style.left = "-90%";
    document.documentElement.style.setProperty("--color-triangle", "transparent");
	window.removeEventListener("click", handleClick2);
	firstClick = true;
}
function openMobileMenu2() {
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
  document.getElementById("mobile-menu-container").style.left = 0;
  if (prefersDarkScheme.matches) {
	document.documentElement.style.setProperty("--color-triangle", "rgb(66, 66, 66)");
  } else {
    document.documentElement.style.setProperty("--color-triangle", "white");
  }
  window.addEventListener("click", handleClick2);
}
// From https://stackoverflow.com/questions/36541892/how-to-determine-highest-resolution-image-from-srcset
function getHighestResImg(element) {
  if (element.getAttribute("srcset")) {
    return element
      .getAttribute("srcset")
      .split(",")
      .reduce(
        (acc, item) => {
          let [url, width] = item.trim().split(" ");
          width = parseInt(width);
          if (width > acc.width) return { width, url };
          return acc;
        },
        { width: 0, url: "" }
      ).url;
  }
  return element.getAttribute("src");
}
function responsiveImages() {
  const emInPx = parseInt(window.getComputedStyle(document.getElementById("site-head-container")).getPropertyValue('font-size'));
  const fullWidth = parseInt(getComputedStyle(document.getElementById("post-content-body-container")).width)
  let wideWidth = fullWidth - (8 * emInPx); // Width of the post-content-body
  if (window.innerWidth < 501) {wideWidth = fullWidth - (window.innerWidth * 0.22)};
  // Parse the figure elements containing images
  let figureElems = document.getElementsByClassName("kg-image-card");
  for (let i = 0; i < figureElems.length; i++) {
	  let figureWidth = parseInt(getComputedStyle(figureElems.item(i)).width);
	  let imgElem = figureElems.item(i).firstElementChild;
	  let imgWidth = parseInt(getComputedStyle(imgElem).width);
	  let imgTagWidth = imgElem.getAttribute("width");
	  let imgHeight = parseInt(getComputedStyle(imgElem).height);
	  let imgTagHeight = imgElem.getAttribute("height");
	  let hasCaption = figureElems.item(i).classList.contains("kg-card-hascaption");
	  let figcaptionElem;
	  let figcaptionWidth;
	  if (hasCaption) {
		  figcaptionElem = figureElems.item(i).lastElementChild;
		  figcaptionWidth = parseInt(getComputedStyle(figcaptionElem).width);
	  }
	  // Identify the size of the card
	  let cardSize = "regular";
	  if (figureElems.item(i).classList.contains("kg-width-wide")) {
		  cardSize = "wide";
	  }
	  if (figureElems.item(i).classList.contains("kg-width-full")) {
		  cardSize = "full";
	  }
	  // Process according to the card size
	  switch(cardSize) { // Center horizontally the image if it is wider than the content body.
		case "regular":
		  if (Math.abs(parseInt(getComputedStyle(figureElems.item(i)).width) - wideWidth) < 2) {
			const offset = (imgWidth - wideWidth) / 2;
	        imgElem.style.left = offset + "px";
	        imgElem.style.position = "relative";
			let highestResImgURL = getHighestResImg(imgElem);
			imgElem.removeAttribute("srcset");
            imgElem.src = highestResImgURL; // Improve image definition
			if (hasCaption) { // Overlay the caption
			  figcaptionElem.style.left = (imgWidth - wideWidth - 2 + figcaptionWidth) + "px";
	          figcaptionElem.style.position = "relative";
			}
		  }
		  else {
			imgElem.style.position = "static";
			if (hasCaption) { figcaptionElem.style.position = "static"; }
		  }
		  break;
		case "wide":
		  imgElem.style.width = ((imgHeight * imgTagWidth) / imgTagHeight) + "px"; // "auto" in the css does not work on Safari nor iOS
		  if (imgWidth > wideWidth) { // Improve image definition
		    let highestResImgURL = getHighestResImg(imgElem);
			imgElem.removeAttribute("srcset");
            imgElem.src = highestResImgURL;
		  }
		  if (!hasCaption) {break;}
	      if ((figcaptionWidth + imgWidth) > wideWidth) { // Overlay the caption
			figcaptionElem.style.left = 0.5 * (imgWidth + figcaptionWidth - wideWidth) - 6 + "px";
			figcaptionElem.style.position = "relative";
	      } else { // Do not overlay the caption
		    figcaptionElem.style.position = "static";
	      }
	      break;
	    case "full":
		  imgElem.style.width = ((imgHeight * imgTagWidth) / imgTagHeight) + "px"; // "auto" in the css does not work on Safari nor iOS
		  if (imgWidth > fullWidth) { // Improve image definition
		    let highestResImgURL = getHighestResImg(imgElem);
			imgElem.removeAttribute("srcset");
            imgElem.src = highestResImgURL;
		  }
		  if (!hasCaption) {break;}
		  if ((figcaptionWidth + imgWidth) > fullWidth) { // Overlay the caption
		    figcaptionElem.style.left = 0.5 * (imgWidth + figcaptionWidth - fullWidth) - 4 + "px";
		    figcaptionElem.style.position = "relative";
	      }
	      else { // Do not overlay the caption
		    figcaptionElem.style.position = "static";
	      }
	  }
  }
}
function responsiveTitle() {
  // Reduce the font size of the h1 title until it fits into the header.
  var emInPx = parseInt(window.getComputedStyle(document.getElementById("site-head-container")).getPropertyValue('font-size'));
  var titleWidth = document.getElementById("post-content-title").offsetWidth;
  var headerWidth = document.getElementById("post-content-header").offsetWidth;
  var titleFontSize = parseInt(getComputedStyle(document.getElementById("post-content-title")).fontSize);
  if ( (titleFontSize > emInPx) && (titleWidth > headerWidth) ){
	document.getElementById("post-content-title").style.fontSize = (0.95 * titleFontSize) + "px";
	responsiveTitle(); // Recursion
	}
}


/* END POST.JS */

/**
 * Infinite Scroll
 * Used on all pages where there is a list of posts (homepage, tag index, etc).
 *
 * When the page is scrolled to 300px from the bottom, the next page of posts
 * is fetched by following the the <link rel="next" href="..."> that is output
 * by {{ghost_head}}.
 *
 * The individual post items are extracted from the fetched pages by looking for
 * a wrapper element with the class "post-card". Any found elements are appended
 * to the element with the class "post-feed" in the currently viewed page.
 */

(function (window, document) {
    // next link element
    var nextElement = document.querySelector('link[rel=next]');
    if (!nextElement) {
        return;
    }

    // post feed element
    var feedElement = document.querySelector('#post-feed');
    if (!feedElement) {
        return;
    }

    var buffer = 300;

    var ticking = false;
    var loading = false;

    var lastScrollY = window.scrollY;
    var lastWindowHeight = window.innerHeight;
    var lastDocumentHeight = document.documentElement.scrollHeight;

    function onPageLoad() {
        if (this.status === 404) {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            return;
        }

        // append contents
        var postElements = this.response.querySelectorAll('article.post-card');
        postElements.forEach(function (item) {
            // document.importNode is important, without it the item's owner
            // document will be different which can break resizing of
            // `object-fit: cover` images in Safari
            item.getElementsByTagName("time")[0].innerText=formatDate(new Date(item.getElementsByTagName("time")[0].getAttribute('datetime')));
			item.getElementsByClassName("post-card-title")[0].innerHTML = item.getElementsByClassName("post-card-title")[0].textContent; //segment
            feedElement.appendChild(document.importNode(item, true));
			if (item.getElementsByTagName("p").length == 1) {
               responsivePostcardExcerpt(document.getElementById("post-feed").lastChild);
			}
        });

        // set next link
        var resNextElement = this.response.querySelector('link[rel=next]');
        if (resNextElement) {
            nextElement.href = resNextElement.href;
        } else {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
        }

        // sync status
        lastDocumentHeight = document.documentElement.scrollHeight;
        ticking = false;
        loading = false;
    }

    function onUpdate() {
        // return if already loading
        if (loading) {
            return;
        }

        // return if not scroll to the bottom
        if (lastScrollY + lastWindowHeight <= lastDocumentHeight - buffer) {
            ticking = false;
            return;
        }

        loading = true;

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = 'document';

        xhr.addEventListener('load', onPageLoad);

        xhr.open('GET', nextElement.href);
        xhr.send(null);
    }

    function requestTick() {
        ticking || window.requestAnimationFrame(onUpdate);
        ticking = true;
    }

    function onScroll() {
        lastScrollY = window.scrollY;
        requestTick();
    }

    function onResize() {
        lastWindowHeight = window.innerHeight;
        lastDocumentHeight = document.documentElement.scrollHeight;
        requestTick();
    }

    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onResize);

    requestTick();
})(window, document);
